import React from "react";
import { Plus, Minus } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export const FaqCards = ({ question, answer, isActive, onClick }) => {
  return (
    <div className="border-b-[.5px] border-[#4f4d4da7] md:w-[90%] w-[90vw]">
      <article className="flex items-center justify-between pt-2 md:pb-8 pb-6">
        <h2 className="cursor-pointer font-semibold md:text-lg" onClick={onClick}>
          {question}
        </h2>
        <ul>
          {!isActive ? (
            <li>
              <button onClick={onClick}>
                <Plus />
              </button>
            </li>
          ) : (
            <li>
              <button onClick={onClick}>
                <Minus />
              </button>
            </li>
          )}
        </ul>
      </article>

      <AnimatePresence>
        {isActive && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
            className="overflow-hidden"
          >
            <div className="p-4 lg:p-2 -mt-3">
              <p>{answer}</p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
